import { render, staticRenderFns } from "./Denuncia.vue?vue&type=template&id=8892a9b2&scoped=true"
import script from "./Denuncia.vue?vue&type=script&lang=js"
export * from "./Denuncia.vue?vue&type=script&lang=js"
import style0 from "./Denuncia.vue?vue&type=style&index=0&id=8892a9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8892a9b2",
  null
  
)

export default component.exports